import useFetch from 'use-http';

import { API_ROUTES } from '../../../constants';
import type {
  TAPIFetchFieldsList,
  TTechDetailsContextResponse,
  TTechDetailsContext,
} from './fetch-context.hook.types';

export const useAPIFetchTechDetailsContext = (): TAPIFetchFieldsList => {
  const { get, error, loading, response, data } =
    useFetch<TTechDetailsContextResponse>(API_ROUTES.APPLICATIONS);

  async function fetchTechDetailsContext(): Promise<TTechDetailsContext> {
    const data = await get('/tech-details/context');

    return data?.data;
  }

  return {
    data: data?.data,
    loading,
    error,
    loaded: response.ok,
    fetchTechDetailsContext,
  };
};
